<template>
  <section class="simple-form" id="simple-form">
    <div class="wrapper">
      <UIButton variant="primary" size="xl" @click="openFeedback">
        Записаться на приём
      </UIButton>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { FormField } from '~/types/pages';
import UIButton from '~/components/UI/button/UIButton.vue';
import { useFeedbackWidget } from '~/composables/useFeedbackWidget';
import './styles.scss';

interface Props {
  title: string;
  formKey: string;
  helpText: string;
  fields: FormField[];
}

defineProps<Props>();

const { open: openFeedback } = useFeedbackWidget();
</script>

<style scoped></style>
